var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsOrdersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0205 22.4536C69.2242 22.9886 70 24.1823 70 25.4996V54.7054C70 55.9159 69.3437 57.0313 68.2855 57.6192L41.6188 72.4341C40.6121 72.9934 39.3879 72.9934 38.3812 72.4341L11.7145 57.6192C10.6563 57.0313 10 55.9159 10 54.7054L10 25.4996C10 24.1823 10.7758 22.9886 11.9795 22.4536L38.6462 10.6017C39.5081 10.2187 40.4919 10.2187 41.3538 10.6017L68.0205 22.4536Z",
    fill: "#003F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8904 14.0814L25.3333 27.7243V43.019L31.9999 46.3523V31.647L57.5168 17.4709L49.8904 14.0814Z",
    fill: "#003F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsOrdersIcon);
export default __webpack_public_path__ + "static/media/reports-orders-icon.a3a0842fa213dd1b5b56dda082537652.svg";
export { ForwardRef as ReactComponent };